import React from "react";
import { toneClasses } from "@/lib/format";

export function StatusBadge({ pct, label }) {
  const tone = pct >= 100 ? "green" : pct >= 80 ? "orange" : "red";
  const dot = { green: "🟢", orange: "🟠", red: "🔴" };
  return (
    <span
      data-testid="status-badge"
      className={`inline-flex items-center gap-1.5 text-xs font-semibold px-2.5 py-1 rounded-full border ${toneClasses[tone]}`}
    >
      <span className="text-[9px]">{dot[tone]}</span>
      {label ?? `${pct}%`}
    </span>
  );
}

export function SectionTitle({ icon: Icon, title, desc, right }) {
  return (
    <div className="flex items-start justify-between gap-4 mb-6 flex-wrap">
      <div className="flex items-center gap-3">
        {Icon && (
          <div className="h-11 w-11 rounded-xl bg-[#C9A24B]/15 border border-[#C9A24B]/25 flex items-center justify-center">
            <Icon className="h-5 w-5 text-[#C9A24B]" />
          </div>
        )}
        <div>
          <h2 className="font-heading text-2xl sm:text-3xl font-light tracking-tight text-white">{title}</h2>
          {desc && <p className="text-sm text-slate-400 mt-0.5">{desc}</p>}
        </div>
      </div>
      {right}
    </div>
  );
}

export function MetricCard({ label, value, sub, icon: Icon, tone = "gold" }) {
  const tones = {
    gold: "from-[#C9A24B] to-[#a07d33]",
    sky: "from-sky-500 to-cyan-600",
    indigo: "from-indigo-500 to-violet-600",
    emerald: "from-emerald-500 to-teal-600",
    rose: "from-rose-500 to-pink-600",
  };
  return (
    <div
      data-testid={`metric-${String(label).toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
      className="surface p-5 transition-[transform,border-color] duration-200 hover:-translate-y-0.5 hover:border-[#C9A24B]/30"
    >
      <div className="flex items-center justify-between mb-3">
        <span className="text-xs font-semibold tracking-wider text-slate-400 uppercase">{label}</span>
        {Icon && (
          <div className={`h-8 w-8 rounded-lg bg-gradient-to-br ${tones[tone]} flex items-center justify-center`}>
            <Icon className="h-4 w-4 text-white" />
          </div>
        )}
      </div>
      <div className="font-mono font-bold text-2xl sm:text-3xl tracking-tight text-white">{value}</div>
      {sub && <div className="text-xs text-slate-400 mt-1.5">{sub}</div>}
    </div>
  );
}

export function EmptyState({ icon: Icon, title, desc }) {
  return (
    <div className="flex flex-col items-center justify-center py-16 text-center">
      {Icon && <Icon className="h-10 w-10 text-slate-600 mb-3" />}
      <div className="font-heading font-semibold text-slate-300">{title}</div>
      {desc && <div className="text-sm text-slate-500 mt-1 max-w-sm">{desc}</div>}
    </div>
  );
}

export const CHART_COLORS = ["#C9A24B", "#38BDF8", "#818CF8", "#34D399", "#F472B6", "#FB923C", "#2DD4BF", "#FBBF24"];
export const CHART_GRID = "#1e293b";
export const CHART_AXIS = "#64748b";
export const CHART_TOOLTIP = { backgroundColor: "#0f1729", border: "1px solid #334155", borderRadius: 12, color: "#fff" };
